// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".home-text-section-image--MyErY{display:block;border-radius:10px;overflow:hidden;width:100%;max-width:100%;height:auto}.home-text-section-video--Wji8D{aspect-ratio:600/337;object-fit:cover;background-color:#fafafb}.home-text-section-copy--fJw73{max-width:58ch;text-wrap:pretty}.home-text-section-row--kON8M{row-gap:32px;padding-block:32px}@media all and (min-width: 768px){.home-text-section-row--kON8M{padding-block:40px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"home-text-section-image": "home-text-section-image--MyErY",
	"home-text-section-video": "home-text-section-video--Wji8D",
	"home-text-section-copy": "home-text-section-copy--fJw73",
	"home-text-section-row": "home-text-section-row--kON8M"
};
export default ___CSS_LOADER_EXPORT___;
